/**
 * Default output quality for Amplience-transformed images (1-100).
 * implicit `fmt=auto` default (measured ≈ qlt 75). Setting `qlt=60` explicitly
 * webp/avif at 60 is visually on par with jpeg ~75 for photographic product imagery.
 *
 * Keep this as the single source of truth so <Image> requests and any manual
 * <link rel="preload"> URLs stay byte-identical (a mismatch downloads twice).
 */
export const AMPLIENCE_IMAGE_QUALITY = 60;

export const amplienceImageLoader = ({ src, width }: { src: string; width: number }) => {
  return encodeURI(src) + '?fmt=auto&' + 'w=' + width + '&qlt=' + AMPLIENCE_IMAGE_QUALITY;
};

/**
 * Build an absolute image URL for use in raw <img> tags (e.g. magnifier library).
 * next/image loaders can resolve relative src, but third-party libs need a full URL.
 */
function toAbsoluteImageUrl(src: string, width: number): string {
  const withParams = amplienceImageLoader({ src, width });
  if (withParams.startsWith('http://') || withParams.startsWith('https://')) {
    return withParams;
  }
  return 'https://cdn.media.amplience.net/' + (withParams.startsWith('/') ? withParams.slice(1) : withParams);
}

/** Build small and large image URLs for react-image-magnifiers (PDP zoom). */
export function getMagnifierImageUrls(
  src: string,
  smallWidth: number = 672,
  largeWidth: number = 2400,
): { imageSrc: string; largeImageSrc: string } {
  return {
    imageSrc: toAbsoluteImageUrl(src, smallWidth),
    largeImageSrc: toAbsoluteImageUrl(src, largeWidth),
  };
}
